import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
    return (
        <div className="privacy-policy-container">
            <div className="privacy-policy-content">
                <h1>Privacy Policy</h1>

                <p>This Privacy Policy explains how <strong>Immo 3.0</strong> ("the App") collects, uses, and protects information when you use our Facebook integration.</p>

                <p>By using this App, you agree to the collection and use of information in accordance with this policy.</p>

                <h2>1. About the App</h2>
                <p><strong>Immo 3.0</strong> is a Facebook Developer application created to automate posting images and captions to the <strong>Immo 3.0</strong> Facebook Page using workflow automation tools such as n8n.</p>
                <p>The App is intended for Page management and content publishing only and is not designed for general public user interaction.</p>

                <h2>2. Information We Access</h2>
                <p>The App only accesses the minimum data required to perform its intended functionality. This includes:</p>
                <ul>
                    <li><strong>Public Profile Information</strong> – Basic information provided by Facebook (such as name and user ID) to identify the connected account.</li>
                    <li><strong>Pages List</strong> – To identify Facebook Pages the user manages.</li>
                    <li><strong>Page Engagement Data</strong> – To read basic engagement metrics (such as reactions or comments count).</li>
                    <li><strong>Page Post Management</strong> – To publish images and captions to the <strong>Immo 3.0</strong> Facebook Page.</li>
                    <li><strong>Business Management Information</strong> – To verify and manage business-owned Facebook Pages.</li>
                </ul>

                <h2>3. How We Use This Information</h2>
                <p>The data accessed by the App is used strictly for the following purposes:</p>
                <ul>
                    <li>Posting images and captions to the <strong>Immo 3.0</strong> Facebook Page</li>
                    <li>Managing and identifying Facebook Pages connected to the account</li>
                    <li>Automating content publishing workflows</li>
                </ul>
                <p>We do not use this data for advertising, profiling, or tracking users.</p>

                <h2>4. Data Storage and Security</h2>
                <p><strong>Immo 3.0</strong> does not permanently store personal user data on external servers. Any access tokens or temporary data used for automation are handled securely and only for operational purposes.</p>
                <p>We take reasonable measures to protect all information accessed through the App and prevent unauthorized access.</p>

                <h2>5. Data Sharing</h2>
                <p>We do not sell, trade, or share your information with third parties.</p>
                <p>Data is only shared with Facebook as required to perform the App's core functionality and comply with Facebook Platform Policies.</p>

                <h2>6. Data Deletion</h2>
                <p>If you wish to revoke access or request deletion of any data associated with this App, you can:</p>
                <ul>
                    <li>Remove the App from your Facebook account settings</li>
                    <li>Contact us using the details provided below</li>
                </ul>
                <p>Upon removal, the App will no longer be able to access your Facebook data.</p>

                <h2>7. Changes to This Privacy Policy</h2>
                <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page. Continued use of the App after changes are made constitutes acceptance of the updated policy.</p>

                <h2>8. Contact Information</h2>
                <p>If you have any questions or concerns about this Privacy Policy or the App, you may contact us at:</p>
                <ul>
                    <li>Email: <a href="mailto:immo3.contact@gmail.com">immo3.contact@gmail.com</a></li>
                    <li>Facebook Page: <a href="https://www.facebook.com/Immo3.0" target="_blank" rel="noopener noreferrer">Immo 3.0</a></li>
                </ul>

                <p className="last-updated">Last updated: January 2026</p>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
